import React from 'react';
import { Link } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import { SIGN_IN } from '../../constants/routes';
import PasswordForgetForm from '../../components/PasswordForgetForm/PasswordForgetForm';
import styles from '../../constants/stylesDefault';
import SmallPaper from '../../components/Layout/SmallPaper';

const SignInLink = () =>
  <p>
    <Link to={SIGN_IN}>Se connecter</Link>
  </p>;

const PasswordForgetPage = () =>
  <SmallPaper>
    <div style={styles.center}>
      <img alt="Koboo" src="/logo.svg" style={styles.logo}/>
      <Typography variant="h5" gutterBottom>Mot de passe oublié</Typography>
      <PasswordForgetForm />
      <SignInLink />
    </div>
  </SmallPaper>;

export default PasswordForgetPage;



// WEBPACK FOOTER //
// ./src/containers/PasswordForgetPage/PasswordForgetPage.jsx